import { render } from "./Order.vue?vue&type=template&id=3968f32f&scoped=true&bindings={}"
import script from "./Order.vue?vue&type=script&lang=ts"
export * from "./Order.vue?vue&type=script&lang=ts"

import "./Order.vue?vue&type=style&index=0&id=3968f32f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3968f32f"

export default script